var _defs, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgPatternHeroDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 640,
    height: 640,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D0202",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D0202",
    stopOpacity: 0.498,
    offset: "100%"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#a)",
    transform: "matrix(0 1 1 0 0 0)",
    cx: 320,
    cy: 320,
    r: 320,
    fillRule: "evenodd",
    opacity: 0.309
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgPatternHeroDesktop);
export default __webpack_public_path__ + "static/media/bg-pattern-hero-desktop.fdd40c2d831de2cec06b2089b1c0b09f.svg";
export { ForwardRef as ReactComponent };